export var ActivityReason;
(function (ActivityReason) {
    ActivityReason["Attachment"] = "Attachment";
    ActivityReason["Comment"] = "Comment";
    ActivityReason["CommentReply"] = "CommentReply";
    ActivityReason["Default"] = "Default";
    ActivityReason["Edit"] = "Edit";
    ActivityReason["Meeting"] = "Meeting";
    ActivityReason["Mention"] = "Mention";
    ActivityReason["MyAnalytics"] = "MyAnalytics";
    ActivityReason["News"] = "News";
    ActivityReason["None"] = "None";
    ActivityReason["Open"] = "Open";
    ActivityReason["Pdf"] = "Pdf";
    ActivityReason["Share"] = "Share";
    ActivityReason["SnoozeExpiry"] = "SnoozeExpiry";
    ActivityReason["Task"] = "Task";
    ActivityReason["Trending"] = "Trending";
    ActivityReason["Video"] = "Video";
})(ActivityReason || (ActivityReason = {}));
//# sourceMappingURL=ActivityReason.js.map